import { Anchor } from "@mantine/core"
import { IconAlertCircle } from "@tabler/icons-react"
import { InfoBox } from "@tfg/ui"
import { Trans, useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

export const EcoscoreRenderer = () => {
  const { t } = useTranslation("communicationStudio")
  return (
    <InfoBox
      variant="warning"
      icon={<IconAlertCircle />}
      title={t("tabs.content.componentModal.ecoscore.title")}
      message={
        <Trans
          ns="communicationStudio"
          i18nKey="tabs.content.componentModal.ecoscore.warning"
          components={{
            link1: (
              <Anchor
                href="https://affichage-environnemental.ecobalyse.beta.gouv.fr"
                c="orange.9"
                target="_blank"
              />
            ),
            link2: (
              <Anchor
                component={Link}
                to="/data-transfer/export"
                c="orange.9"
                target="_blank"
              />
            ),
          }}
        />
      }
    />
  )
}
